import styled from 'styled-components';

export default styled.span`
  display: block;
  ${p => p.nowrap && `white-space: nowrap`}
`;
